export enum OrderType {
  Delivery = 'delivery',
  Shuttle = 'shuttle',
  Taxi = 'taxi',
  Airport = 'airport',
}